export default __webpack_public_path__ + "static/media/face_1_43.2b709563.png";